<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-purple" sprite="voicemail-2" />
          Voicemails
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-purple" sprite="voicemail-2" />
            Voicemails
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px"></i>
            Total: {{ total | number }}
          </el-tag>
        </el-col>
      </el-row>
      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button
            class="ml-10 hidden-xs-only"
            @click="doExport"
          >
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          stripe
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createVisible"
      :createProcessing="createProcessing"
      :clearFormFields="clearFormFields"
      :numInUse="numInUse"
      :ivrOptions="ivrOptions"
      :draggableDestTypes="draggableDestTypes"
      :cid-num-options="cidnumOptions"
      :branch-options="branchOptions"
      @checkNumber="mailbox = $event"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
      @fetchCidnumOptions="remoteMethodForCidnums"
    />

    <edit-form
      :editVisible="editVisible"
      :editProcessing="editProcessing"
      :clearFormFields="clearFormFields"
      :ivrOptions="ivrOptions"
      :timezoneOptions="timezoneOptions"
      :selectedVoicemail="selectedVoicemail"
      :draggableDestTypes="draggableDestTypes"
      :cid-num-options="cidnumOptions"
      :branch-options="branchOptions"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
      @fetchCidnumOptions="remoteMethodForCidnums"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "lodash";

import feathersClient from "../../../feathers/feathers-client";
import CreateForm from "./components/createForm.vue";
import EditForm from "./components/editForm";
import { globalEventBus } from "../../../globalEventBus";
import {ExportToCsv} from "export-to-csv";

export default {
  name: "VoicemailsTable",

  components: {
    CreateForm,
    EditForm
  },

  data() {
    return {
      draggableDestTypes: [
        "SPECIAL",
        "CUSTOM",
        "IVR",
        "VOICEMAIL",
        "PLAYBACK",
        "HUNTLIST",
        "EXT",
        "QUEUE",
        "SMS",
        "MUSICONHOLD",
        "CONDITION"
      ],
      search: "",
      total: 0,
      voicemailChannel: null,
      tableData: [],
      allVoicemails: [],
      numInUse: false,
      visibleActionsId: "",
      createProcessing: false,
      editProcessing: false,
      tableLoading: false,
      editVisible: false,
      createVisible: false,
      clearFormFields: false,
      selectedVoicemail: null,
      mailbox: null,
      ivrOptions: null,
      timezoneOptions: [],
      cidnumOptions: [],
      branchOptions: [],
      cidnumQuery: "",
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-purple" sprite="voicemail" />
                </div>
              ];
            }
          }
        },
        {
          field: "mailbox",
          title: "Mailbox",
          sortable: true,
          minWidth: 100,
          showOverflow: false
        },
        {
          field: "fullName",
          title: "Name",
          sortable: true,
          minWidth: 150,
          showOverflow: true
        },
        {
          field: "password",
          title: "PIN",
          sortable: true,
          minWidth: 100,
          showOverflow: false
        },
        {
          field: "email",
          title: "Email",
          sortable: true,
          minWidth: 150,
          showOverflow: true
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.findVoicemails();
      this.queryBranches();
      this.fetchIvrOptions();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.voicemailChannel } });
      this.joinSocketChannel();
    },

    user() {
      this.findVoicemails();
      this.queryBranches();
      if (!this.voicemailChannel) {
        this.joinSocketChannel();
      }
    },

    mailbox: debounce(function() {
      feathersClient
        .service("check-voicemail-number")
        .find({
          query: { tenantId: this.selectedTenant.id, number: this.mailbox }
        })
        .then(res => {
          this.numInUse = res.inUse;
        });
    }, 500),

    search: debounce(function() {
      this.searchVoicemails();
    }, 500),

    cidnumQuery: debounce(function() {
      this.fetchCidNums(this.cidnumQuery);
    }, 500)
  },

  methods: {
    ...mapActions("voicemails", {
      createVoicemail: "create",
      editVoicemail: "patch",
      deleteVoicemail: "remove"
    }),

    doExport(){
      const data = [...this.tableData];
      if(data.length){

        const writeData = data.map(item => ({
          mailbox: item.mailbox ? item.mailbox : '',
          name: item.fullName ? item.fullName : '',
          pin: item.password,
          email: item.email ? item.email : ''
        }));

        const options = {
          filename: 'voicemails',
          showLabels: true,
          headers: ['Mailbox', 'Name', 'PIN', 'Email']
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    async fetchCidNums(query) {
      const didsService = feathersClient.service("dids");
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 10,
        },
      };

      if (query && query.length) {
        didParams.query.number = { $like: `%${query}%` };
      }

      const results = await didsService.find(didParams);

      this.cidnumOptions = results.map(num => ({
        key: num.id,
        label: num.number,
        disabled: false,
      }));

    },

    // Filtering Outbound Caller Id
    remoteMethodForCidnums(query) {
      this.cidnumQuery = query;
    },
    queryBranches() {
      this.branchOptions = [];
      feathersClient
        .service("branches")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 },
          },
        })
        .then((res) => {
          this.branchOptions = [...res];
        }).catch( () => {
          this.branchOptions = [];
      });
    },

    searchVoicemails() {
      if (this.search.length) {
        this.tableData = this.allVoicemails.filter(
          item =>
            item.mailbox.toLowerCase().includes(this.search.toLowerCase()) ||
            item.fullName.toLowerCase().includes(this.search.toLowerCase()) ||
            (item.email
              ? item.email.toLowerCase().includes(this.search.toLowerCase())
              : "")
        );
      } else {
        this.tableData = [...this.allVoicemails];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    findVoicemails() {
      this.tableLoading = false;
      this.tableData = [];
      feathersClient
        .service("voicemails")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { fullName: 1 }
          }
        })
        .then(res => {
          this.tableData = [...res];
          this.allVoicemails = [...res];
          this.total = res.length;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },

    openEditModal(id) {
      this.clearFormFields = false;
      feathersClient
        .service("voicemails")
        .get(id)
        .then(res => {
          this.selectedVoicemail = res;
          this.editVisible = true;
        });
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    createOperation(params) {
      const createBody = { ...params };

      // check voicemailLength is array and has 2 elements
      if(Array.isArray(createBody.voicemailLength)){

        createBody.minLength = createBody.voicemailLength[0] || 2;
        createBody.maxLength = createBody.voicemailLength[1] || 300;

        // remove voicemailLength from createBody
        delete createBody.voicemailLength;
      }

      this.$confirm("Process voicemail create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          this.createVoicemail(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.findVoicemails();
              this.cancelOperation("create");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editData) {
      const editBody = { ...editData };
      delete editBody.mailbox;

      // check voicemailLength is array and has 2 elements
      if(Array.isArray(editBody.voicemailLength)){

        editBody.minLength = editBody.voicemailLength[0] || 2;
        editBody.maxLength = editBody.voicemailLength[1] || 300;

        // remove voicemailLength from editBody
        delete editBody.voicemailLength;
      }

      this.$confirm("Process voicemail edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          this.editVoicemail([this.selectedVoicemail.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success"
              });
              this.findVoicemails();
              this.cancelOperation("edit");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      this.numInUse = false;
      if (type === "create") {
        this.createVisible = false;
        this.createProcessing = false;
      } else if (type === "edit") {
        this.editVisible = false;
        this.editProcessing = false;
      }
    },

    deleteOperation(id) {
      this.$confirm("Process voicemail delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.deleteVoicemail(id)
            .then(() => {
              this.tableLoading = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
              this.findVoicemails();
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    fetchIvrOptions() {
      feathersClient
        .service("ivrs")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 }
          }
        })
        .then(res => {
          this.ivrOptions = [...res];
        }).catch(e => {
          this.ivrOptions = [];
      });
    },

    getTimezones() {
      feathersClient
        .service("timezones")
        .find({
          query: {
            $sort: { name: 1 }
          }
        })
        .then(res => {
          this.timezoneOptions = [...res];
        });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "voicemails",
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {
        this.voicemailChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    removeListeners() {
      feathersClient.service("voicemails").removeListener("patched");
      feathersClient.service("voicemails").removeListener("created");
      feathersClient.service("voicemails").removeListener("removed");
      globalEventBus.$off("appReconnected");
    }
  },

  filters: {
    number(value) {
      return !isNaN(value)
        ? new Intl.NumberFormat("en-US").format(value)
        : value;
    }
  },

  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    if(this.user){
      this.tableLoading = true;
      this.queryBranches();
    }

    feathersClient.service("voicemails").on("patched", data => {
      //find the record in the table data.
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allVoicemails.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allVoicemails.splice(updateAllIndex, 1, data);
      }
    });

    feathersClient.service("voicemails").on("created", data => {
      this.tableData.push(data);
      this.allVoicemails.push(data);
    });

    feathersClient.service("voicemails").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allVoicemails.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allVoicemails.splice(indexAllToRemove, 1);
      }
    });
  },

  mounted() {
    if (this.user) {
      this.findVoicemails();
      this.fetchIvrOptions();
      this.getTimezones();
      this.fetchCidNums();
      this.joinSocketChannel();
    }
  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.voicemailChannel } });
  }
};
</script>
